import { Box } from '@mui/material';
import styles from './StatusLabelTask.module.scss';
import classNames from 'classnames/bind';
import { memo } from 'react';
import { ITaskStatusResponse } from '~/utils/interface/task';

const cx = classNames.bind(styles);

type StatusLabelProps = {
  variant: ITaskStatusResponse | undefined;
};

function StatusLabelTask(props: StatusLabelProps) {
  const { variant } = props;

  return (
    <Box
      className={cx('status-info')}
      style={{ backgroundColor: `${variant?.backgroundColor}`, color: `${variant?.color}` }}
    >
      {variant?.name}
    </Box>
  );
}

export default memo(StatusLabelTask);
